export default "__VITE_ASSET__wZxZ00sx__"